import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState = {
  messages: [],
}

export const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    pushMssageToSnackbar: (state, action) => {
      const id = Date.now().toString()
      state.messages.push({
        ...action.payload,
        id,
      })
    },
    removeMessageFromSnackbar: (state, action) => {
      state.messages = state.messages.filter(
        (message) => message.id !== action.payload,
      )
    },
  },
})

export const { pushMssageToSnackbar, removeMessageFromSnackbar } =
  snackbarSlice.actions
export default snackbarSlice.reducer
